export const homeNotificationMessage: Record<string, string> = {
  warning: "Failed to load video",
  featuredInsightsWarning: "Failed to load Featured Insights",
};

export const FEATURED_INSIGHTS_ENDPOINT =
  "/entitlements/v1/user/cms/portals?featured=true&sortKey=Effective_Published_Date&pageSize=10";
